<template>
    <div class="guide_box">
        <div class="triangle" style=""></div>
        <div style="display: flex; justify-content: center; position: relative; margin-bottom: 20px;">
            <div>
                <img style="width: 38px;" :src="isPro ? popupText.proText.src : popupText.commonText.src" alt="">
            </div>
            <div @click="closePositionPopup" style="width: 30px; height: 30px; top: -3px; right: 0; position: absolute; display: flex; align-items: center; justify-content: end;">
                <img style="width: 12px; margin-right: 4px;" :src="require('@/assets/img/black_x_btn_new.png')" alt="">
            </div>
        </div>
        <div style="margin-bottom: 10px;">
            <div style="font-size: 14px; line-height: 20px;">{{ isPro ? popupText.proText.title : popupText.commonText.title }}</div>
        </div>
        <div style="margin-bottom: 20px;">
            <div style="font-size: 12px; color: #606060; line-height: 17px;">{{ isPro ? popupText.proText.contents : popupText.commonText.contents }}</div>
        </div>
        <div @click="showMore" style="height: 35px; width: 147px; margin: 0 auto; line-height: 35px; border-radius: 22.5px; box-shadow: 0px 1px 5px 0px #10101433; background-color: #fff; color: #000; text-align: center; font-size: 12px;">더 알아보기</div>
    </div>
</template>

<script>
export default {
    name: 'PositionPopup',
    data() {
        return {
            popupText: {
                commonText: {
                    title: '회원님에게 딱 맞는 포지션을 한 번 찾아볼게요',
                    contents: '사커하우 포지션 찾기를 통해 회원님의 포지션을 찾아볼 수 있어요. 진행해볼까요?',
                    src: require('@/assets/img/no_position.png')
                },
                proText: {
                    title: '회원님이 받을 수 있는 포지션 뱃지가 있어요!',
                    contents: '전문가 피드백이 담긴 포지션 뱃지는 포지션 찾기 PRO를 통해서만 받을 수 있어요. 포지션 찾기 PRO를 진행해볼까요?',
                    src: require('@/assets/img/pro_position.png')
                }
            }
        }
    },
    methods: {
        showMore() {
            if (this.isPro) {
                this.$GlobalStore.addModal('FindPositionProStart', { originallyPosition: this.$GlobalStore.loginInfo().position });
            } else {
                this.$GlobalStore.addModal('FindPositionStart', { start: true, position: this.$GlobalStore.loginInfo().position })
            }
        }
    },
    props: {
        isPro: {
            type: Boolean,
            default: false,
        },
        closePositionPopup: {
            type: Function,
            default: () => { }
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.guide_box {
    width: 187px;
    display: flex;
    flex-direction: column;
    top: 78px;
    justify-content: space-between;
    padding: 18px 11px;
    color: #fff;
    border-radius: 10px;
    background: #F5F5F5;
    position: absolute;
    left: 6%;
    transform: translateX(-50%);
    z-index: 10;
    opacity: 1;
    transition: all 0.5s;
    box-shadow: 0px 5px 30px 0px #210F034D;
    font-weight: 500;
}

.guide_box_off {
    width: 195px;
    height: 160px;
    display: flex;
    flex-direction: column;
    top: 34px;
    justify-content: space-between;
    padding: 18px;
    color: #fff;
    border-radius: 10px;
    background: #0A0D14CC;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    opacity: 0;
    transition: all 0.5s;
    visibility: hidden;
}

.triangle {
    border-top: 0px solid transparent;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #f5f5f5;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    content: "";
    position: absolute;
    top: -14px;
    left: 74.5%;
    transform: translateX(-50%);
}
</style>